import { useAutocompleteSource } from '@eas/common-web';
import { DictNoteAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useNotes() {
  return useAutocompleteSource<DictNoteAutocomplete>({
    url: `${EvidenceApiUrl.DICT_NOTES}/autocomplete`,
  });
}
